import { Stack, Typography, type SxProps, type Theme } from "@mui/material";

interface Props {
  totalCount: number;
  align: "left" | "right";
  sx?: SxProps<Theme>;
}

export const RecordsCounter = ({ totalCount, sx, align }: Props) => {
  return (
    <Stack
      direction="row"
      useFlexGap
      spacing={0.5}
      sx={{
        flex: 1,
        alignItems: "center",
        py: 0.4,
        justifyContent: align === "left" ? "flex-start" : "flex-end",
        ...sx,
      }}
    >
      <Typography variant="caption" color="secondary">
        Records:
      </Typography>
      <Typography variant="caption">{totalCount}</Typography>
    </Stack>
  );
};

export default RecordsCounter;
